import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { provideRouter } from "@angular/router";
import { routes } from "./app.routes";
import { provideClientHydration } from "@angular/platform-browser";
import { provideFirebaseApp, initializeApp } from "@angular/fire/app";
import { getDatabase, provideDatabase } from "@angular/fire/database";
import { environment } from "../environments/environment";
import { provideAuth, getAuth } from "@angular/fire/auth";
import { getLocalStorage } from "./local-storage";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from "@angular/common/http";
import { httpInterceptor } from "./interceptor/http-interceptor.interceptor";
import { provideStorage, getStorage } from "@angular/fire/storage";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import { appEffects, appStore } from "./app.state";
import { provideStore } from "@ngrx/store";
import { provideEffects } from "@ngrx/effects";
import { provideNgIdleKeepalive } from "@ng-idle/keepalive";
import { metaReducers } from "./states/login/metaReducer";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    importProvidersFrom([
      provideFirebaseApp(() => initializeApp(environment.firebase)),
      provideAuth(() => getAuth()),
      provideDatabase(() => getDatabase()),
      provideStorage(() => getStorage()),
    ]),
    { provide: "LOCALSTORAGE", useFactory: getLocalStorage },
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([httpInterceptor]), withFetch()),
    provideNgIdleKeepalive(),
    provideStore(appStore, { metaReducers }),
    provideEffects(appEffects),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: environment.production,
    }),
  ],
};
